import { useProductRoomI18nFormModelContext } from "../../../../../../model";
import { useProductExistingRoomI18nFormModelContext } from "../../../../context";

export const useUpdateButton = () => {
	const { viewModel } = useProductRoomI18nFormModelContext();
	const { onUpdate } = useProductExistingRoomI18nFormModelContext();

	const isValid = !viewModel.hasError && viewModel.isDirty;

	return {
		isValid,
		onUpdate,
	};
};
